import React from "react";
import {createRoot} from "react-dom/client";
import {App} from "./components/App";
import {recordAdoptionEvents} from "../services/telemetry";
import {getRuntimeConfig} from "../services/runtimeConfig";

Office.onReady(() => {
  recordAdoptionEvents();
  // Office renders the manifest's DisplayName above the pane (fixed at
  // manifest upload, not runtime-configurable) — this only affects the
  // pane's own document title, e.g. in a detached/undocked window.
  document.title =
    getRuntimeConfig().APP_NAME || process.env.APP_NAME || "NOS-GPT Excel";
  const container = document.getElementById("root");
  if (container) {
    const root = createRoot(container);
    root.render(<App />);
  }
});
